module.exports = __webpack_public_path__ + "img/picto-visites.33ce7124.svg";